import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";

export class ProgressUI {

  constructor(el) {
    this.$el = $(el);
  }

  setProgress(progress) {
    for (let i = 1; i <= 5; i++) {
      const isActive = (i <= progress);
      // gsap.set(this.$el.find(`.progress-el[data-index='${i}']`), {autoAlpha: isActive})
      this.$el.find(`.progress-el[data-index='${i}']`).toggleClass("completed", isActive);
    }
  }

  reset() {
    this.setProgress(0)
  }

}
